import Vue from 'vue'
import * as types from '../mutation-types'
import helpers from '@/util/helpers'

// initial state
const state = {
  user: {},
  users: [],
  pagination: {}
}

// getters
const getters = {
  user: state => state.user,
  users: state => state.users,
  users_pagination: state => state.pagination
}

// actions
const actions = {
  getUsers ({ state, commit }, filters) {
    Vue.axios.get('/users/', {params: filters}).then((response) => {
      commit(types.RECEIVE_USERS, { response })
    })
  },
  getUser ({ state, commit }, id) {
    Vue.axios.get(`/users/${id}/`, {params: {id: id}}).then((response) => {
      commit(types.RECEIVE_USER, { response })
    })
  },
  saveUser ({ state, commit }) {
    Vue.axios.put(`/users/${state.user.id}/`, state.user).then((response) => {
      commit(types.RECEIVE_USER, { response })
    })
  }
}

// mutations
const mutations = {
  [types.RECEIVE_USERS] (state, { response }) {
    state.users = response.data.results
    state.pagination = helpers.pagination(response.headers)
  },
  [types.RECEIVE_USER] (state, { response }) {
    state.user = response.data.results
  },
  [types.UPDATE_USER_VALUE] (state, value) {
    state.user = Object.assign(state.user, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
